export const ADD_TO_CART = 'ADD_TO_CART'
export const SET_CART_ITEMS = 'SET_CART_ITEMS'
export const SET_CHECKOUT_STATUS = 'SET_CHECKOUT_STATUS'
export const RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS'
export const SET_LIST_NAME = 'SET_LIST_NAME'





// WEBPACK FOOTER //
// ./src/store/mutation-types.js